// ============================================================
// Suppliers module manifest — R3 retrofit (2026-04-24).
//
// Mirrors inventory's shape almost exactly: one route, one schema,
// no dependencies, fits every industry pack except Services (where
// purchase-side relationships are usually absent).
//
// What this is the source of truth for:
//   - 1 sidebar route (suppliers, in 'main' section)
//   - 2 Firestore collections (suppliers + supplieritems M:N link)
//   - 4 permission strings in the suppliers namespace (R6)
//   - 2 dashboard widget descriptors (active suppliers KPI, top-spend list)
//   - 3 industry packs that ship suppliers by default
//
// IMPORTANT: changes to `id` are BREAKING (tenantConfig.enabledModules,
// permissions, URL hashes all reference it).
// ============================================================

export default {
  id:          'suppliers',
  name:        'Suppliers',
  version:     '1.0.0',
  description: 'Supplier master + per-supplier item link catalog (M:N).',

  load: () => import('./index.js'),

  routes: [
    {
      id:       'suppliers',
      label:    'Suppliers',
      icon:     '🤝',
      section:  'main',
      sidebarPosition: 40,
      // 2026-05-04 sidebar-leak fix — gate by literal `suppliers.read`.
      // Only roles that explicitly grant suppliers.read see this in the sidebar
      // (today: director + admin via '*'/__ALL_EXCEPT_TENANT_CONFIG__,
      // trading.sales, retail.store-manager). Staff / shop-floor / production-
      // supervisor / manufacturing.sales do NOT get suppliers.read by default.
      visible:  (role, hasPerm) => hasPerm('suppliers.read'),
      mount:    'mountSuppliersList',
      unmount:  'unmountSuppliersList'
    }
  ],

  // Firestore collections this module owns. Same names as the legacy paths.
  schemas: [
    'suppliers',       // master
    'supplieritems'    // M:N link to inventory
  ],

  // Permission strings. R6 maps roles → permissions per industry.
  permissions: [
    'suppliers.read',
    'suppliers.write',
    'suppliers.archive',
    'suppliers.delete'
  ],

  // No dependencies — Suppliers is foundation. Other modules (procurement,
  // sales) depend on suppliers; suppliers depends on nothing.
  dependencies: [],

  fitsIndustries: ['manufacturing', 'trading', 'retail'],

  functions: [],

  // Dashboard widgets this module contributes. Mounted by the manifest-driven
  // dashboard composition layer (R3 — see pages/dashboard.js).
  // section hint: 'kpi' lives in the KPI strip; 'left-col' / 'right-col' in
  // the two-column lower area; 'hr-block' is HR's special row.
  dashboardWidgets: [
    {
      id:           'suppliers-active-count',
      label:        'Suppliers',
      section:      'kpi',
      order:        50,
      defaultRoles: ['director', 'admin', 'manager', 'inventory', 'sales']
    }
  ]
};
